import { STRPIE_PAYMNET, CLIENT_SECRET, PAYMENT_AMOUNT, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    strpiePayment: false,
    clientSecret: "",
    paymentAmount: 0
}

export const strpiePaymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case STRPIE_PAYMNET:
            return {
                ...state,
                strpiePayment: action.payload
            };
        case CLIENT_SECRET:
            return {
                ...state,
                clientSecret: action.payload
            };
        case PAYMENT_AMOUNT:
            return {
                ...state,
                paymentAmount: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;;
    }
}